"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// generated by Fragment Matcher plugin
const graphql_fragment_types_1 = __importDefault(require("@aurora/shared-generated/types/graphql-fragment-types"));
exports.default = graphql_fragment_types_1.default.possibleTypes;
//# sourceMappingURL=possibleTypes.js.map